const state = {
  types: [],
  unknownType: {
    id: -1,
    name: "Не известен"
  },
};

export default state;
